import { render, staticRenderFns } from "./VjsfEditor.vue?vue&type=template&id=33cc0ad6&scoped=true&"
import script from "./VjsfEditor.vue?vue&type=script&lang=js&"
export * from "./VjsfEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc0ad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VCard,VCardText,VInput})
